/* eslint-disable no-console */

import axios from "axios";

const API_VERSION = "v1";
const SERVICES = /(newsitems|filters|eventreports)/;

const call = ({
  method,
  services = SERVICES,
  apiVersion = API_VERSION
}) => async ({ url, payload, authJWT, headers = {} }) => {
  try {
    const [path, query] = url.split("?");
    const service =
      path.match(services) !== null ? path.match(services)[0] : "";
    const formattedPath = `/${path.replace(
      services,
      `${service}/api/${apiVersion}`
    )}`;

    const callParams = [
      `${formattedPath}${query ? `?${query}` : ""}`,
      ...(payload ? [payload] : []),
      {
        headers: {
          ...headers,
          ...(authJWT
            ? {
                Authorization: `Bearer ${authJWT}`
              }
            : {})
        }
      }
    ];
    const { data } = await axios[method](...callParams);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export default ({ services = SERVICES, apiVersion = API_VERSION }) =>
  ["get", "post", "put", "patch", "delete"].reduce(
    (res, method) => ({
      ...res,
      [method]: call({ method, services, apiVersion })
    }),
    {}
  );
